export const PENDING = "pending";
export const FULFILLED = "fulfilled";
export const REJECTED = "rejected";
export const RESET = "reset";
